exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon[data-v-0dd1b595] {\n  color: #526da5 !important;\n}\n.text[data-v-0dd1b595] {\n  color: rgba(0, 0, 0, 0.7);\n}\n", ""]);

// exports
